import { queryOptions } from "@tanstack/react-query"
import { request } from "@utils/request"

const p = {
  query: `
  query($categoryId: Int!, $articleType: [ArticleType]) {
    category( id: $categoryId, status: [PUBLISHED, DRAFT, REVIEW], articleType: $articleType) {
      id
      name
      type
      articles {
        id
        status
        attributes
        type
        content {
          language
          question
          author
          attributes
          publishDate
          createdDate
          lastModifiedDate
          alternativeViews {
            viewId
            viewName
            question
            answer
            contentType
          }
        }
        usageCount
      }
    }
      }`,
  variables: {
    categoryId: 561,
    articleType: ["CONTENT", "DECISION_TREE", "MACRO"],
  },
}

export const knowledgebaseArticles = queryOptions({
  queryKey: ["kb", "list"],

  queryFn: () => request.post("api/kb/graphql", { json: p }).json(),
})
